import React, { useContext } from 'react';
import { Switch, Typography, Card, Space } from 'antd';
import { BulbOutlined, BulbFilled } from '@ant-design/icons';
import { ThemeContext } from '../contexts/ThemeContext';
import '../styles/Common.css';

const { Title, Text } = Typography;

const Settings = () => {
  const { isDark, toggleTheme } = useContext(ThemeContext);

  return (
    <div className="common-container">
      <Title level={3}>설정</Title>
      <Card title="화면 설정" style={{ maxWidth: 480 }}>
        <Space style={{ justifyContent: 'space-between', width: '100%' }}>
          <Space>
            {isDark ? <BulbFilled style={{ fontSize: 18, color: '#fadb14' }} /> : <BulbOutlined style={{ fontSize: 18 }} />}
            <div>
              <Text strong>다크 모드</Text>
              <br />
              <Text type="secondary" style={{ fontSize: 12 }}>어두운 배경으로 전환합니다</Text>
            </div>
          </Space>
          <Switch
            checked={isDark}
            onChange={toggleTheme}
            checkedChildren="Dark"
            unCheckedChildren="Light"
          />
        </Space>
      </Card>
    </div>
  );
};

export default Settings;
